import React, { useState } from 'react';
import { Col, Container, Image, Modal, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';

import backgroundImage from '../../assets/Images/Login_background_Image.gif';
import vizLogo from '../../assets/Images/Vizlink_logo.png';

import FormikControl from '../../layouts/Input/FormikControl';

import { signIn } from './AuthAction';


const Loginpage = props => 
{
  ////////////////////////////////////////////////////////////////////////////////////////////////////

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [showModal_ForgotPassword, setShowModal_ForgotPassword] = useState(false);

  const [loginObject, setLoginObject] = useState({ email: '', password: '',rememberme : false });

  const loginValidationSchema = Yup.object().shape
  ({
    email: Yup.string()
              .required('Email is required'),
    password: Yup.string()
              .min(8, 'Password length must be 8 or more characters')
              .required('Password is required'),
  });
  const ChangeRememberMeCheckBox = (event) => {
    setLoginObject({...loginObject, rememberme: event.target.checked})
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////

  function LoginUser()
  {
    props.signIn(loginObject.email, loginObject.password, loginObject.rememberme);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////

  return(
    <>
      <div 
        className='login-page'
        style=
        {{
          backgroundSize: 'cover',
          backgroundImage: `url(${backgroundImage})`,
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className='login-box elevation-4'>

          <div className='card-header text-center'>
            <Link 
              className='brand-link clearfix'
              to={'/login'} 
            >
              <Image
                src={vizLogo}
                alt={'VizLink App Logo'}
              />
            </Link>
          </div>

          <div className='card-body'>
            <p className='login-box-msg'>
              {'Login to start your session'}
            </p>

            <Formik
              enableReinitialize
              validationSchema={loginValidationSchema}
              onSubmit={() => LoginUser()}
              initialValues={loginObject}
            >
              {
                (formik) =>
                (
                  <Form autoComplete={'off'}>
                    <Modal.Body>
                      <Container>

                        <Row>
                          <Col xs={12} md={12}>
                            <div className='form-group'>
                              <FormikControl
                                formik={formik}
                                control='input'
                                type='text'
                                label='Email'
                                name='email'
                                value={loginObject.email}
                                handleOnChange={text => setLoginObject({ ...loginObject, email: text})}
                              />
                            </div>
                          </Col>

                          <Col xs={12} md={12}>
                            <div className='form-group'>
                              <FormikControl
                                formik={formik}
                                control='input'
                                type='password'
                                label='Password'
                                name='password'
                                value={loginObject.password}
                                handleOnChange={text => setLoginObject({ ...loginObject, password: text})}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12} md={12}>
                            <div className='custom-checkbox'>
                              <label 
                                className='custom-control-label' 
                                style={{ width: '50%' }}
                                htmlFor='customCheck1' 
                              >
                                <input
                                  id='customCheck1'
                                  className='custom-control-input-info'
                                  style={{ marginRight: '6%' }}
                                  type='checkbox'
                                  value={loginObject.rememberme}
                                  onChange={ChangeRememberMeCheckBox}
                                />
                                {'Remember Me'}
                              </label>
                            </div>
                          </Col>
                        </Row>
                      
                      </Container>
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: 'space-between', marginRight: '2.5%', }}>
                      <Link 
                        className='forgot-password'
                        style={{ padding: '2.5%', }}
                        to={'/ForgetPassword'} 
                      >
                        <a>{'Forgot Password?'}</a>
                      </Link>

                      <input
                        className='btn btn-primary'
                        type='submit'
                        value='Login'
                      />
                    </Modal.Footer>
                  </Form>
                )
              }
            </Formik>
          </div>

        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => 
{
  return{
    isSignedIn: state.auth.isSignedIn,
    userId: state.auth.userId,
    token: state.auth.token,
  }
}

export default connect(mapStateToProps, { signIn })(Loginpage);
